module.exports = __webpack_public_path__ + "img/main-gallery6-mob.e1a5fbdf.jpg";